module.exports = function enablePageReloadUponAuthentication() {
  const TOTAL_TIMES_TO_CHECK_PCLN = 30
  const CHECKING_INTERVAL = 1000
  const MAX_WAIT_TIME = 30000
  let headerLoaded = false
  let checkedCount = 0
  let timerCheckGlobalHeaderLoaded = null
  function pageReloadChecker() {
    timerCheckGlobalHeaderLoaded = setInterval(() => {
      checkedCount++
      if (checkedCount >= TOTAL_TIMES_TO_CHECK_PCLN || headerLoaded) {
        clearInterval(timerCheckGlobalHeaderLoaded)
        timerCheckGlobalHeaderLoaded = null
      }
      if (window.PCLN && window.PCLN.pclnEventDispatcher && !headerLoaded) {
        headerLoaded = true
        window.PCLN.pclnEventDispatcher.register('GLOBAL_PCLN_CUSTOMER_SIGNIN', () => {
          window.location.reload()
        })

        window.PCLN.pclnEventDispatcher.register('GLOBAL_PCLN_CUSTOMER_SIGNOUT', () => {
          window.location.reload()
        })
      }
    }, CHECKING_INTERVAL)
  }
  pageReloadChecker()
  setTimeout(() => {
    if (timerCheckGlobalHeaderLoaded) {
      clearInterval(timerCheckGlobalHeaderLoaded)
    }
  }, MAX_WAIT_TIME)
}
